/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { BrowserRouter } from "react-router-dom";
import App from "App";
import React from "react";
import ReactDOM from "react-dom/client";
// import { render } from "react-dom";
import "./index.css";

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";
import { SnackbarProvider } from "layouts/ecommerce/product/hooks/SnackbarProvider";
// import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
// import { store } from "./layouts/ecommerce/product/all-products/redux/store";
// import store from 'datamanagement/store'

// const root = ReactDOM.createRoot(document.getElementById('root'));

import { store } from "./layouts/ecommerce/product/all-products/redux/store";

// SENTRY DISABLED - Uncomment to re-enable error monitoring
// import * as Sentry from "@sentry/react";
// import EnvConfig from "./config/EnvConfig";

// Sentry.init({
//   dsn: process.env.SENTRY_DSN,
//   environment: process.env.MY_ENV,
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions

//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: [
//     EnvConfig().baseConfigUrl,
//     new RegExp(`^${EnvConfig().baseConfigUrl}/`),
//   ],

//   // Filtering based on error type (customizable)
//   beforeSend(event) {
//     if (event.exception) {
//       const errorType = event.exception.values[0].type;
//       const errorMessage = event.exception.values[0].value;
//       if (
//         ["TypeError", "SyntaxError", "Error", "FirebaseError"].includes(errorType) ||
//         errorMessage.includes("Material-UI") ||
//         errorMessage.includes("Firebase")
//       ) {
//         return null;
//       }
//     }
//     if (event.tags && event.tags.source === "firebase") {
//       return null;
//     }
//     return event;
//   },
// });

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <CookiesProvider>
    <BrowserRouter>
      <Provider store={store}>
        <SoftUIControllerProvider>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </SoftUIControllerProvider>
      </Provider>
    </BrowserRouter>
  </CookiesProvider>
);

if (process.env.NODE_ENV === "development") {
  if (module["hot"]) {
    module["hot"].accept();
  }
}
